import _ from 'lodash'
import { Map, Record } from 'immutable'

import { ACTIVE_ITEM, TOGGLE_SUBMENU } from './constants'
import { MENU_DEFAULT_PATH } from '../../constants'

export const MenuRecord = Record({
    active: MENU_DEFAULT_PATH,
    toggles: Map(),
})

export default (state = new MenuRecord(), action = {}) => {
    switch (action.type) {
        case ACTIVE_ITEM: {
            const rootPath = _.initial(_.get(action, 'data.path'), [])
            const keyToActive = _.get(action, 'data.keyToActive', null)

            // delete all toggles settings
            const deleteState = state.delete('toggles')

            // set open to true for every item in pathToOpen
            const pathToOpen = [...rootPath, keyToActive]
            const newState = _.reduce(
                pathToOpen,
                (acc, key, index) => acc.setIn(['toggles', ..._.take(pathToOpen, index + 1), 'open'], true),
                deleteState
            )

            // set path to open as active
            return newState.set('active', pathToOpen)
        }
        case TOGGLE_SUBMENU: {
            const togglePath = _.get(action, 'data.path', [])
            const pathToActive = _.get(action, 'data.pathToActive')

            const currentActivePath = state.get('active')
            const isSameSubMenu = _.isEqual(togglePath, _.take(currentActivePath, togglePath.length))
            const currentOpenState = state.getIn(['toggles', ...togglePath, 'open'], false)
            // only toggle item of menu
            if (isSameSubMenu) return state.setIn(['toggles', ...togglePath, 'open'], !currentOpenState)

            // delete all toggles settings
            const deleteState = state.delete('toggles')

            // set open to true for every item in pathToOpen
            const pathToOpen = [...togglePath, ...pathToActive]
            const newState = _.reduce(
                pathToOpen,
                (acc, key, index) => acc.setIn(['toggles', ..._.take(pathToOpen, index + 1), 'open'], true),
                deleteState
            )

            // set path to open as active
            return newState.set('active', pathToOpen)
        }
        default:
            return state
    }
}
